import React, { useRef } from 'react'
import styles from './NotificationsManager.module.scss'
import Notification from './Notification'
import { NotificationsManagerProps } from './types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

const classNames = {
  enter: styles['notification-enter'],
  enterActive: styles['notification-enter-active'],
  exit: styles['notification-exit'],
  exitActive: styles['notification-exit-active']
}

// CSSTransition needs a nodeRef: without one it falls back to ReactDOM.findDOMNode,
// which was removed in React 19. TransitionGroup injects its transition props
// (in, onExited, ...) into this component, so pass them through to CSSTransition.
const NotificationTransition = ({ text, ...transitionProps }) => {
  const nodeRef = useRef<HTMLDivElement>(null)
  return (
    <CSSTransition {...transitionProps} nodeRef={nodeRef} timeout={500} classNames={classNames}>
      <Notification ref={nodeRef} text={text} />
    </CSSTransition>
  )
}

const NotificationsManager = (props: NotificationsManagerProps) => (
  <TransitionGroup className={styles['notifications-manager']}>
    {props.notifications.map(({ id, text }) => (
      <NotificationTransition key={id} text={text} />
    ))}
  </TransitionGroup>
)

export default NotificationsManager
